import React, { Component } from 'react';
import axios from 'axios';
import PageHeader from '../components/PageHeader/PageHeader.js';
import styles from './Contentpage.module.css';
import ShareBar from '../components/ShareBar/sharebar';
import PageContent from '../components/PageContent/PageContent';
import Highlights from '../components/Highlights/Highlights.js';
import Feedback from '../components/Feedback/Feedback';
import { DateUtil } from '../utils/DateUtil.js';
import ReactGA from 'react-ga';
import APPCONST from '../constants/constants';
import SiteTracking from '../components/SiteTracking/SiteTracking';
import './emagazine.css';
// import Survey from '../components/Survey/survey'

ReactGA.initialize(APPCONST.googleAnalyticsCode);

class ContentPage extends Component{
	constructor(props){
		super(props);
		this.state={
			content:{},
			highlights:[],
			feedback:null,
		};
	}

	componentDidMount=()=>{
		this.getPageData(this.props.content_id);
		ReactGA.pageview(window.location.pathname+window.location.search);
	}

	componentDidUpdate(prevProps){
		if(prevProps.content_id!==this.props.content_id)
			this.getPageData(this.props.content_id);
  	}

	getPageData(content_id){
		const params={
			contentid:content_id,
			region:window.global.content_hub.region,
		};

		let content=axios.get(window.global.content_hub.API+'/api/single_content',{params});
		let highlights=axios.get(window.global.content_hub.API+'/api/related_content',{params});
		axios
			.all([content,highlights])
			.then(
				axios.spread((content_data,highlight_data)=>{
					window.scrollTo(0,0);
					this.setState({
						content:JSON.parse(content_data.data.content)[0] || {},
						highlights:highlight_data.data.filter((d,i)=>i<4),
						feedback:content_data.data.feedback
					});
				})
			)
			.catch((err)=>console.log(err));
	}


	renderPageHeader=()=>{

		let headerBanner = null;
		let headerText = null;
		let headerVideo = null;

		if (this.state.content.Metadata && this.state.content.Metadata.header_banner) {
			headerBanner = <img alt="" className={styles.image_background} src={`${window.global.content_hub.ASSETS}/images/${this.state.content.Metadata.header_banner}?`} height="100%" width="100%" />;
		}

		if (this.state.content.Metadata && this.state.content.Metadata.header_text) {
			headerText = <img alt="" className={styles.image_text} src={`${window.global.content_hub.ASSETS}/images/${this.state.content.Metadata.header_text}`} height="100%" width="100%" />;
		}

		if (this.state.content.Metadata && this.state.content.Metadata.header_video) {
			headerVideo = (
				<video width="100%" height="100%" autoPlay loop muted>
					<source src={`${window.global.content_hub.ASSETS}videos/${this.state.content.Metadata.header_video}`} type="video/webm" />
					Your browser does not support HTML video.
				</video>
			)
		}

		if (headerVideo) {
			return headerVideo
		} else {
			return (
				<div className={styles.image_container}>
					{headerBanner}
					{headerText}
				</div>
			)
		}
	}


	render(){
		if(this.state.content.ID===undefined)
			return (<React.Fragment />);

		return (
			<React.Fragment>
				<SiteTracking action="Load Content" data={{ content_id: this.state.content.ID }} duration={true} />
				<div className={styles.container}>
					{this.state.content.Content_Type!=='AG_ALERT'
						?<PageHeader>
							{this.renderPageHeader()}
						</PageHeader>
						:null}
					<div className={styles.nav_bar}>
						<div className={styles.single_content_wrapper}>
							<div id="mainArticleContent" dangerouslySetInnerHTML={{__html:`
<div class="row article-author">
	<div class="col s12 m4 14">${DateUtil.formatDateOnly(this.state.content.Metadata.published_date)}</div>
	<div class="col s12 m8 18 ${styles.article_author}">${this.state.content.Metadata.author?`By ${this.state.content.Metadata.author}`:''}</div>
</div>`+this.state.content.ContentHTML}}/>
							<Highlights>
								{this.state.highlights.map((content) => (
									<PageContent
										key={content.ID}
										Title="Highlights"
										data={content}
									/>
								))}
							</Highlights>
							<ShareBar
								text={this.state.content.Title}
								pos="left"
							/>
							{this.state.content.Content_Type === 'ARTICLE'
								? <Feedback content_id={this.state.content.ID} feedback={this.state.feedback} />
								: null}
						</div>
					</div>
				</div>
				{/* <Survey></Survey> */}
			</React.Fragment>
		);
	}
}

export default ContentPage;
